import React, { useRef, useEffect, useState } from 'react';
import Barcode from 'react-barcode'

import LabelCardHome from './LabelCardHome'
import { GrupoLogo } from 'assets/icons'
import useOrderStore from 'store/client/orderStore'
import { ReactComponent as Zarahomefirst } from 'assets/zarahome/zarafirst.svg'
import { ReactComponent as Zarahomeeee } from '../../../../../assets/zarahome.svg'
import { ReactComponent as Zarahomefirst2 } from 'assets/zarahome/zarafirst.svg'
import { ReactComponent as Zarakucuker } from 'assets/zarahome/path2304.svg'
import { ReactComponent as Hursan } from 'assets/zarahome/hursan.svg'








export default function Page1({ sizeData, selectColor = 0, barcodeValue, data, isHursan, isZorlu = false }) {
  const { referance } = useOrderStore()
  const isBlack = referance?.backgroundColor === 'B'
  const[variant,setVariant] = useState("default")
  const barcodeRef = useRef(null);
  const barbarRef = useRef(null);
  const barbarRef2 = useRef(null);
  const barbarRef3 = useRef(null);
  const barbarRef4 = useRef(null);
  const [fontSize, setFontSize] = useState(16.5);


console.log("dataaaaa",sizeData)

  useEffect(() => {
      if (data?.sizeGroup?.variant) {
        setVariant(data.sizeGroup.variant)
      }
    console.log("variantxx",sizeData)
    // DOM'un render edilmesi için kısa bir gecikme ekle
    setTimeout(() => {
      // Sadece aktif variant için DOM manipülasyonu yap
      if (variant === "default") {
        const svgElement = barcodeRef.current?.querySelector('svg');
        const textElement = svgElement?.querySelector('text');
        if (textElement) {
          textElement.style.fill = isBlack ? 'white' : '';
        }

        const svgElement2 = barbarRef.current?.querySelector('svg');
        const textElement2 = svgElement2?.querySelector('text');
        if (textElement2) {
          textElement2.style.letterSpacing = '0';
          textElement2.setAttribute('x', '70.3');
          textElement2.setAttribute('y', '26.4');
        }

        // Font boyutunu kontrol et ve ayarla
        const container = barbarRef.current?.querySelector('div[style*="position: absolute"]');
        if (container && sizeData) {
          const cmText = sizeData.cm?.replace(/\s*x\s*/g, 'x') || '';
          const inchesText = sizeData.inches?.replace(/\s*x\s*/g, 'x') || '';
          
          // Container genişliği (221px)
          const containerWidth = 221;
          const marginLeft = 12; // inches için margin
          const availableWidth = containerWidth - marginLeft;
          
          // Her iki yazıyı ayrı ayrı ölç
          const tempElement = document.createElement('div');
          tempElement.style.position = 'absolute';
          tempElement.style.visibility = 'hidden';
          tempElement.style.fontSize = '16.5px';
          tempElement.style.fontWeight = '600';
          tempElement.style.fontFamily = 'Arial, sans-serif';
          tempElement.style.whiteSpace = 'nowrap';
          
          // CM yazısını ölç
          tempElement.textContent = cmText;
          document.body.appendChild(tempElement);
          const cmWidth = tempElement.offsetWidth;
          document.body.removeChild(tempElement);
          
          // Inches yazısını ölç
          tempElement.textContent = inchesText;
          document.body.appendChild(tempElement);
          const inchesWidth = tempElement.offsetWidth;
          document.body.removeChild(tempElement);
          
          const totalTextWidth = cmWidth + inchesWidth + marginLeft;
          
          // Eğer toplam yazı genişliği container'dan büyükse font boyutunu küçült
          if (totalTextWidth > containerWidth) {
            const newFontSize = (containerWidth / totalTextWidth) * 16.5;
            setFontSize(Math.max(newFontSize, 10)); // Minimum 10px
          } else {
            setFontSize(16.5);
          }
        }
        
      }

      if (variant === "letterdefault") {
        const svgElement2 = barbarRef2?.current?.querySelector('svg');
        const textElement2 = svgElement2?.querySelector('text');
        if (textElement2) {
          textElement2.style.letterSpacing = '0';
          textElement2.setAttribute('x', '70.3');
          textElement2.setAttribute('y', '26.4');
          console.log("textElement2 bulundu:", textElement2);
        }
      }

      if (variant === "kidsin") {
        const svgElement3 = barbarRef3?.current?.querySelector('svg');
        const textElement3 = svgElement3?.querySelector('text');
        if (textElement3) {
          textElement3.style.letterSpacing = '0';
          textElement3.setAttribute('x', '70.3');
          textElement3.setAttribute('y', '26.4');
          console.log("textElement3 bulundu:", textElement3);
        }
      }

      if (variant === "newkidschina") {
        const svgElement3 = barbarRef3?.current?.querySelector('svg');
        const textElement3 = svgElement3?.querySelector('text');
        if (textElement3) {
          textElement3.style.letterSpacing = '0';
          textElement3.setAttribute('x', '70.3');
          textElement3.setAttribute('y', '26.4');
          console.log("textElement3 bulundu:", textElement3);
        }
      }

      if (variant === "rug") {
        const svgElement4 = barbarRef4?.current?.querySelector('svg');
        const textElement4 = svgElement4?.querySelector('text');
        if (textElement4) {
          textElement4.style.letterSpacing = '0';
          textElement4.setAttribute('x', '70.3');
          textElement4.setAttribute('y', '26.4');
          console.log("textElement4 bulundu:", textElement4);
        }
      }
    }, 100); // 100ms gecikme
  
  }, [barcodeValue, isBlack, sizeData, data?.sizeGroup?.variant, variant]);  // variant'ı da dependency olarak ekle

  // Data yüklenene kadar bekleyelim
  if (!data || !data.sizeGroup || !sizeData) {
    return <div>Yükleniyor...</div>
  }

  if (variant === "default") {
    return (
  

      <div ref={barcodeRef} className="flex flex-wrap gap-3" style={{ position: "relative"}}>
      {isHursan && <Hursan width="240mm" height="25mm" style={{ position: "absolute", top: "0.6", left: "-32"}} />}

      <div style={{position:"relative",marginLeft: isHursan ? "120mm" : "0" }}>
        <LabelCardHome type="front" number={1} isZorlu={isZorlu}  >
          <div className="flex items-center h-full" >
            <div className="inline-flex flex-col tracking-[.10rem]">
            <div
        style={{
          right: '11.94mm',
          left:'auto',
          borderColor: isHursan ? "transparent" : "#ee1d25",
          borderWidth: "0.01px",
          width: "1px",
          transform: "scaleX(0.2)", // 1px’i 0.3px’e indirir
          top:"5%",
          height:"85%",
        }}
        className={`absolute  border-s border `}
     
      ></div>



            <div style={{position:"absolute",top:"0",left:"0",border: isHursan ? "0.2px solid transparent" : "0.2px solid #e30613",width:"120mm",height:"25mm",opacity:isHursan ? 0.5 : 1}}>              </div>
              <Zarahomefirst width="120mm" height="auto" style={{ width: "120mm", height: "auto", position: "absolute", top: "0.6", left: "4.2" }} />
              <div ref={barbarRef} className="x1212dsa" style={{ position: "absolute", bottom: "2.8px", left: "40.8px" }}>
                <div style={{ position: "absolute", left: 156, bottom: 14.2, textAlign: "left" }}>

                  <p
                    className="text-left"
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
{`${data.articleNo.replace(/\//g, '\\')}\\${data.washingLabel[selectColor].colorCode.replace(/\//g, '\\')}\\${sizeData.sCode.replace(/\//g, '\\')}`}

</p>
                </div>
                <div style={{ position: "absolute", left: 145, bottom: -3.2, minWidth: 221, maxWidth: 221, display:"flex",flexDirection:"row",justifyContent:"center" }}>
                  <p
                    className="arial-bold"
                    style={{
                      fontSize: `${fontSize}px`,
                      fontWeight:600,
                      lineHeight: `${fontSize * 1.2}px`,
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >
                    {sizeData.cm?.replace(/\s*x\s*/g, 'x')}
                  </p>
                  <p className="arial-bold"
                    style={{
                      fontSize: `${fontSize}px`,
                      lineHeight: `${fontSize * 1.2}px`,
                      fontWeight:600,
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:"12px"
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                </div>
                <div style={{ position: "absolute", left: 240.513, bottom: -3.5, minWidth: 120, textAlign: "right" }}>
              
                </div>
                {data.washingLabel[selectColor].bagmm && data.sizeGroupId === "444" &&
                  <div style={{ position: "absolute", left: 255.64, bottom: 15.9, minWidth: 50 }}>
                    <p
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontWeight: "normal",
                        fontSize: "12px",
                        lineHeight: "14.4px",
                        letterSpacing: "0px",
                        color: "black",
                      }}
                    >
                      {data.washingLabel[selectColor].bagmm} mm
                    </p>
                  </div>
                }
                {data.washingLabel[selectColor].gramaj && (
                    <div style={{ position: "absolute", left: 310.64, bottom: 15.9, minWidth: 50 }}>
                      <p
                        style={{
                          fontFamily: "Arial, sans-serif",
                          fontWeight: "normal",
                          fontSize: "12px",
                          lineHeight: "14.4px",
                          letterSpacing: "0px",
                          color: "black",
                        }}
                      >
                        {data.washingLabel[selectColor].gramaj} g/m²
                      </p>
                    </div>
                  )}
                  <div  style={{marginBottom:isHursan ? "-3.5px" : "-2.5px",marginLeft: isHursan ? "5.1px" : "3.6px",marginTop:-25}}>
                  <Barcode
  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
  format="ITF14"
  width={1.046}
  height={16.4}
  marginLeft={1}
  marginRight={1}
  marginTop={0.3}
  marginBottom={1}
  background="transparent"
  lineColor={isBlack ? 'black' : 'black'}
  textMargin={1}
  fontSize={12}
  fontOptions="bold"
  font="Arial"
/>
                </div>

                
              </div>
            </div>
          </div>
        </LabelCardHome>
      </div>
      </div>
    )
  }

  if (variant === "letterdefault") {
    return (
      <div ref={barcodeRef} className="flex flex-wrap gap-3" style={{ position: "relative"}}>
        {isHursan && <Hursan width="240mm" height="25mm" style={{ position: "absolute", top: "0.6", left: "-32"}} />}
        <div style={{position:"relative",marginLeft: isHursan ? "120mm" : "0" }}>
        <LabelCardHome type="front" number={1} isZorlu={isZorlu}>
          <div className="flex items-center h-full">
            <div className="inline-flex flex-col tracking-[.10rem]">
            <div
        style={{
          right: '11.94mm',
          left:'auto',
          borderColor: isHursan ? "transparent" : "#ee1d25",
          borderWidth: "0.01px",
          width: "1px",
          transform: "scaleX(0.2)", // 1px'i 0.3px'e indirir
          top:"5%",
          height:"85%"

        }}
        className={`absolute  border-s border `}
     
      ></div>
            <div style={{position:"absolute",top:"0",left:"0",border: isHursan ? "0.2px solid transparent" : "0.2px solid #e30613",width:"120mm",height:"25mm",opacity:isHursan ? 0.5 : 1}}>              </div>
            <Zarahomefirst width="120mm" height="auto" style={{ width: "120mm", height: "auto", position: "absolute", top: "0.6", left: "4.2" }} />        
             <div ref={barbarRef2} className="x1212dsa" style={{ position: "absolute", bottom: "2.8px", left: "40.8px" }}>
       
      
                <div style={{ position: "absolute", left: 158, bottom: 8.03, width: 205, textAlign: "right",display:"flex",flexDirection:"row",justifyContent:"space-between" }}>
                  <p className="arial-bold"
                    style={{
                      fontSize: "16.5px",
                      lineHeight: "19.7px",
                      letterSpacing: "0px",
                      fontWeight:600,
                      color: "black",
                    }}
                  >{sizeData.europe?.replace(/\s*x\s*/g, 'x')}</p>
                      <p
                    className="text-left"
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '13.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
{`${data.articleNo.replace(/\//g, '\\')}\\${data.washingLabel[selectColor].colorCode.replace(/\//g, '\\')}\\${sizeData.sCode.replace(/\//g, '\\')}`}
</p>

                    <p
                  
                  style={{
                    fontFamily: 'Arial, sans-serif',
                    fontWeight: 400,
                    fontSize: '10.14pt',
                    lineHeight: '12.16pt',
                    letterSpacing: '0em',
                    color: '#000',
                  }}
                >
                  {sizeData.cn?.replace(/\s*x\s*/g, 'x')}
                </p>
                </div>
                {data.washingLabel[selectColor].bagmm && data.sizeGroupId === "444" &&
                  <div style={{ position: "absolute", left: 255.64, bottom: 15.9, minWidth: 50 }}>
                    <p
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontWeight: "normal",
                        fontSize: "12px",
                        lineHeight: "14.4px",
                        letterSpacing: "0px",
                        color: "black",
                      }}
                    >
                      {data.washingLabel[selectColor].bagmm} mm
                    </p>
                  </div>
                }
               
                  <div  style={{marginBottom:isHursan ? "-3.5px" : "-2px",marginLeft: isHursan ? "5.1px" : "4.6px",marginTop:-25}}>
                  <Barcode
  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
  format="ITF14"
  width={1.046}
  height={16.4}
  marginLeft={1}
  marginRight={1}
  marginTop={0.3}
  marginBottom={-1}
  background="transparent"
  lineColor={isBlack ? 'black' : 'black'}
  textMargin={2}
  fontSize={12}
  fontOptions="bold"
  font="Arial"
/>
                </div>
              </div>
            </div>
          </div>
        </LabelCardHome>
      </div>
      </div>
    )
  }
  if (variant === "kidsin") {
    return (
      <div ref={barcodeRef} className="flex flex-wrap gap-3" style={{ position: "relative"}}>
        {isHursan && <Hursan width="240mm" height="25mm" style={{ position: "absolute", top: "0.6", left: "-32"}} />}
        <div style={{position:"relative",marginLeft: isHursan ? "120mm" : "0" }}>
        <LabelCardHome type="front" number={1} isZorlu={isZorlu}>
          <div className="flex items-center h-full">
            <div className="inline-flex flex-col tracking-[.10rem]">
            <div
        style={{
          right: '11.94mm',
          left:'auto',
          borderColor: isHursan ? "transparent" : "#ee1d25",
          borderWidth: "0.01px",
          width: "1px",
          transform: "scaleX(0.2)", // 1px'i 0.3px'e indirir
          top:"5%",
          height:"85%"

        }}
        className={`absolute  border-s border `}
     
      ></div>
            <div style={{position:"absolute",top:"0",left:"0",border: isHursan ? "0.2px solid transparent" : "0.2px solid #e30613",width:"120mm",height:"25mm",opacity:isHursan ? 0.5 : 1}}>              </div>
            <Zarahomefirst width="120mm" height="auto" style={{ width: "120mm", height: "auto", position: "absolute", top: "0.6", left: "4.2" }} />    
                <div ref={barbarRef3} className="x1212dsa" style={{ position: "absolute", bottom: "2.8px", left: "40.8px" }}>
                <div style={{ position: "absolute", left: 155, bottom: 12, textAlign: "left" }}>
                  <p
                    className="text-left"
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
{`${data.articleNo.replace(/\//g, '\\')}\\${data.washingLabel[selectColor].colorCode.replace(/\//g, '\\')}\\${sizeData.sCode.replace(/\//g, '\\')}`}
</p>
                </div>
                <div style={{ position: "absolute", left: 281, bottom: 9.4, minWidth: 80,display:"flex",justifyContent:"flex-end" }}>
                  <p
                  
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
                    {sizeData.cn?.replace(/\s*x\s*/g, 'x')}
                  </p>
                </div>
                <div style={{ position: "absolute", left: 145, bottom: -3.2, minWidth: 221, maxWidth: 221, display:"flex",flexDirection:"row",justifyContent:"center" }}>
                  <p
                    className="arial-bold"
                    style={{
                      fontSize: `${fontSize}px`,
                      fontWeight:600,
                      lineHeight: `${fontSize * 1.2}px`,
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >
                    {sizeData.cm?.replace(/\s*x\s*/g, 'x')}
                  </p>
                  <p className="arial-bold"
                    style={{
                      fontSize: `${fontSize}px`,
                      lineHeight: `${fontSize * 1.2}px`,
                      fontWeight:600,
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:"12px"
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                </div>

               
                {data.washingLabel[selectColor].bagmm && data.sizeGroupId === "444" &&
                  <div style={{ position: "absolute", left: 255.64, bottom: 15.9, minWidth: 50 }}>
                    <p
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontWeight: "normal",
                        fontSize: "12px",
                        lineHeight: "14.4px",
                        letterSpacing: "0px",
                        color: "black",
                      }}
                    >
                      {data.washingLabel[selectColor].bagmm} mm
                    </p>
                  </div>
                }
             
                  <div  style={{marginBottom:isHursan ? "-3.5px" : "-2.5px",marginLeft: isHursan ? "5.1px" : "3.6px",marginTop:-25}}>
                  <Barcode
  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
  format="ITF14"
  width={1.046}
  height={16.4}
  marginLeft={1}
  marginRight={1}
  marginTop={0.3}
  marginBottom={-1}
  background="transparent"
  lineColor={isBlack ? 'black' : 'black'}
  textMargin={1}
  fontSize={12}
  fontOptions="bold"
  font="Arial"
/>
                </div>
              </div>
            </div>
          </div>
        </LabelCardHome>
      </div>
      </div>
    )
  }

  if (variant === "newkidschina") {
    return (
      <div ref={barcodeRef} className="flex flex-wrap gap-3" style={{ position: "relative"}}>
        {isHursan && <Hursan width="240mm" height="25mm" style={{ position: "absolute", top: "0.6", left: "-32"}} />}
        <div style={{position:"relative",marginLeft: isHursan ? "120mm" : "0" }}>
        <LabelCardHome type="front" number={1} isZorlu={isZorlu}>
          <div className="flex items-start h-full">
            <div className="inline-flex flex-col tracking-[.10rem]">
            <div
        style={{
          right: '11.94mm',
          left:'auto',
          borderColor: isHursan ? "transparent" : "#ee1d25",
          borderWidth: "0.01px",
          width: "1px",
          transform: "scaleX(0.2)", // 1px'i 0.3px'e indirir
          top:"5%",
          height:"85%"

        }}
        className={`absolute  border-s border `}
     
      ></div>
            <div style={{position:"absolute",top:"0",left:"0",border: isHursan ? "0.2px solid transparent" : "0.2px solid #e30613",width:"120mm",height:"25mm",opacity:isHursan ? 0.5 : 1}}>              </div>
            <Zarahomefirst width="120mm" height="auto" style={{ width: "120mm", height: "auto", position: "absolute", top: "0.6", left: "4.2" }} />    
                <div ref={barbarRef3} className="x1212dsa" style={{ position: "absolute", bottom: "2.8px", left: "40.8px" }}>
                <div style={{ position: "absolute", left: 155, bottom: 12, textAlign: "left" }}>
                  <p
                    className="text-left"
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
{`${data.articleNo.replace(/\//g, '\\')}\\${data.washingLabel[selectColor].colorCode.replace(/\//g, '\\')}\\${sizeData.sCode.replace(/\//g, '\\')}`}
</p>
                </div>
                <div style={{ position: "absolute", left: 281, bottom: 9.4, minWidth: 80,display:"flex",justifyContent:"flex-end" }}>
                  <p
                  
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
                    {sizeData.cn?.replace(/\s*x\s*/g, 'x')}
                  </p>
                </div>
                <div style={{ position: "absolute", left: 155, bottom: -3.2, minWidth: 221, maxWidth: 221, display:"flex",flexDirection:"row",justifyContent:"flex-start" }}>
                  <p
                    className="arial-bold"
                    style={{
                      fontSize: `${fontSize}px`,
                      fontWeight:600,
                      lineHeight: `${fontSize * 1.2}px`,
                      letterSpacing: "0px",
                      color: "black",
                    }}
                  >
                    {sizeData.cm?.replace(/\s*x\s*/g, 'x')}
                  </p>
                  <p className="arial-bold"
                    style={{
                      fontSize: `${fontSize}px`,
                      lineHeight: `${fontSize * 1.2}px`,
                      fontWeight:600,
                      letterSpacing: "0px",
                      color: "black",
                      marginLeft:"6px"
                    }}
                  >{sizeData.inches?.replace(/\s*x\s*/g, 'x')}</p>
                </div>

               
                {data.washingLabel[selectColor].bagmm && data.sizeGroupId === "444" &&
                  <div style={{ position: "absolute", left: 255.64, bottom: 15.9, minWidth: 50 }}>
                    <p
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontWeight: "normal",
                        fontSize: "12px",
                        lineHeight: "14.4px",
                        letterSpacing: "0px",
                        color: "black",
                      }}
                    >
                      {data.washingLabel[selectColor].bagmm} mm
                    </p>
                  </div>
                }
             
                  <div  style={{marginBottom:isHursan ? "-3.5px" : "-2.5px",marginLeft: isHursan ? "5.1px" : "3.6px",marginTop:-25}}>
                  <Barcode
  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
  format="ITF14"
  width={1.046}
  height={16.4}
  marginLeft={1}
  marginRight={1}
  marginTop={0.3}
  marginBottom={-1}
  background="transparent"
  lineColor={isBlack ? 'black' : 'black'}
  textMargin={1}
  fontSize={12}
  fontOptions="bold"
  font="Arial"
/>
                </div>
              </div>
            </div>
          </div>
        </LabelCardHome>
      </div>
      </div>
    )
  }

  if (variant === "rug") {
    return (
      <div ref={barcodeRef} className="flex flex-wrap gap-3" style={{ position: "relative"}}>
        {isHursan && <Hursan width="240mm" height="25mm" style={{ position: "absolute", top: "0.6", left: "-32"}} />}
        <div style={{position:"relative",marginLeft: isHursan ? "120mm" : "0" }}>
        <LabelCardHome type="front" number={1} isZorlu={isZorlu}>
          <div className="flex items-center h-full">
            <div className="inline-flex flex-col tracking-[.10rem]">
            <div
        style={{
          right: '11.94mm',
          left:'auto',
          borderColor: isHursan ? "transparent" : "#ee1d25",
          borderWidth: "0.01px",
          width: "1px",
          transform: "scaleX(0.2)", // 1px'i 0.3px'e indirir
          top:"5%",
          height:"85%",

        }}
        className={`absolute  border-s border `}
     
      ></div>
            <div style={{position:"absolute",top:"0",left:"0",border: isHursan ? "0.2px solid transparent" : "0.2px solid #e30613",width:"120mm",height:"25mm",opacity:isHursan ? 0.5 : 1}}>              </div>
            <Zarahomefirst width="120mm" height="auto" style={{ width: "120mm", height: "auto", position: "absolute", top: "0.6", left: "4.2" }} /> 
                     <div ref={barbarRef4} className="x1212dsa" style={{ position: "absolute", bottom: "2.8px", left: "40.8px" }}>
                <div style={{ position: "absolute", left: 204, bottom: 6, textAlign: "left",minWidth:160,display:"flex",justifyContent:"flex-end" }}>
                  <p
                    className="text-left"
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
{`${data.articleNo.replace(/\//g, '\\')}\\${data.washingLabel[selectColor].colorCode.replace(/\//g, '\\')}\\${sizeData.sCode.replace(/\//g, '\\')}`}
</p>
                </div>
                <div style={{ position: "absolute", left: 281, bottom: 7.4, minWidth: 80,display:"flex",justifyContent:"flex-end",display:"none" }}>
                  <p
                  
                    style={{
                      fontFamily: 'Arial, sans-serif',
                      fontWeight: 400,
                      fontSize: '10.14pt',
                      lineHeight: '12.16pt',
                      letterSpacing: '0em',
                      color: '#000',
                    }}
                  >
                    {sizeData.cn?.replace(/\s*x\s*/g, 'x')}
                  </p>
                </div>
     

               
                {data.washingLabel[selectColor].bagmm && data.sizeGroupId === "444" &&
                  <div style={{ position: "absolute", left: 255.64, bottom: 15.9, minWidth: 50,display:"none" }}>
                    <p
                      style={{
                        fontFamily: "Arial, sans-serif",
                        fontWeight: "normal",
                        fontSize: "12px",
                        lineHeight: "14.4px",
                        letterSpacing: "0px",
                        color: "black",
                      }}
                    >
                      {data.washingLabel[selectColor].bagmm} mm
                    </p>
                  </div>
                }
              
                  <div  style={{marginBottom:isHursan ? "-2px" : "-1px",marginLeft: isHursan ? "7.1px" : "5.6px",marginTop:-25}}>
                  <Barcode
  value={barcodeValue?.length === 13 ? barcodeValue : '0390547180002'}
  format="ITF14"
  width={1.046}
  height={16.4}
  marginLeft={1}
  marginRight={1}
  marginTop={0.3}
  marginBottom={-1}
  background="transparent"
  lineColor={isBlack ? 'black' : 'black'}
  textMargin={0}
  fontSize={12}
  fontOptions="bold"
  font="Arial"
/>
                </div>
              </div>
            </div>
          </div>
        </LabelCardHome>
      </div>
      </div>
    )
  }
  // Diğer senaryolar için boş veri döndür
  return null;
}
